export const CommsCommand = {
  emit: {
    ready: 'emit:ready',
    error: 'emit:error',
    requestLogin: 'emit:request_login',
    openRequestCreated: 'emit:open_request_created',
    chatStart: 'emit:on_chat:start',
    chatEnd: 'emit:on_chat:end',
    rating: 'emit:rating',
    unreadMessages: 'emit:unread_messages',
  },
  get: { config: 'get:config', startup: 'get:startup' },
  bot: {
    setOpen: 'bot:set_open',
    minimize: 'bot:minimize',
    setChatting: 'bot:set_chatting',
  },
  execute: {
    token: 'execute:token',
    login: 'execute:login',
  },
} as const;
